import * as m from "vite-cjs-external-facade:vue";module.exports = m;